module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.22.1.0.box.710.1193.334.35.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.22.1.0.box.710.1193.334.35.q.80"
    }
  }, [_vm._v("MANOR HALL")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.22.2.0.box.593.1247.567.71.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "font-style": "italic",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.22.2.0.box.849.1247.63.24.q.40"
    }
  }, [_vm._v("1859")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "font-weight": "bold"
    },
    attrs: {
      "id": "para.22.2.1.box.593.1286.567.32.q.60"
    }
  }, [_vm._v("On a summer's night—a brutal attack")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.22.3.0.box.128.1368.1503.1071.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.3.0.box.130.1368.1501.203.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.2.0.0"
    }
  }), _vm._v("When Martin Luther Stockard built MANOR HALL in 1859, he gave to Mt. Pleasant the crown jewel of all its antebellum homes. With obvious pride in such an achievement, Mr. Stockard saw to it that his initials and MANOR HALL'S building date were branded forever near the tops of the two front chimneys that rear in towering splendor above the regal shoulders of this grand old place.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.3.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.3.1.box.129.1577.1501.320.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.2.1.0"
    }
  }), _vm._v("As a monument to an era when no pillar could rise too high, no ocean was too wide to cross for the very best of everything, and no purse was spared to bring both about, MANOR HALL crowns the crest of a spacious and gently rising lawn that seems to lift it curiously apart from the hustle and bustle of the present day world beyond. At the same time, its great bulk has a way of hiding from view the \"old Quarters\" and ancient smokehouse that still hover in traditional humility within their own long lost universe of salty timbers, fleeting shadows, and the empty cornucopia of the days that used to be.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.3.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.3.2.box.129.1910.1502.286.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.2.2.0"
    }
  }), _vm._v("If, in all its elegant grandeur, MANOR HALL signified a special triumph on the stage of Martin Luther Stockard's life; so, too, would this same MANOR HALL witness tragedy waiting in the wings of a hot lune night, 1874. While strolling on his front lawn in the peace and quiet of an early summer's evening, Col. Stockard was suddenly and viciously attacked by an unknown assailant who left him for dead in the sultry darkness. Never fully recovering from this brutal assault, Martin Luther Stockard had but three short years left to him as MANOR HALL'S builder and first master.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.3.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.3.3.box.128.2202.1501.237.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.2.3.0"
    }
  }), _vm._v("Ironically, at Col. Stockard's death, title to MANOR HALL passed to one Rev. John Stephenson Frierson, for forty years the beloved pastor of Mt. Pleasant Presbyterian Church. As the founder and moving spirit of historic Hay Long College, this progenitor of MANOR HALL'S present owners had been originally the first white man ever to own the phosphate-rich acres upon which MANOR HALL stands today—long undisputed as the rarest treasure in all of antebellum Mt. Pleasant.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.0.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ec6b67f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content-0036.vue
// module id = 75
// module chunks = 0